function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.0606 22.8209L12.5331 15.8395L10.3636 17.2464L6.73157 15.2101L2 7.91408L14.2034 0L18.935 7.296L19.3127 11.4427L16.8721 13.0256L21.3996 20.007C22.1766 21.2052 21.8352 22.8064 20.6371 23.5834C19.4389 24.3605 17.8377 24.0191 17.0606 22.8209ZM15.9383 13.9619L20.3149 20.7105C20.7034 21.3095 20.5327 22.1102 19.9336 22.4987C19.3345 22.8872 18.5339 22.7165 18.1454 22.1174L13.7688 15.3688L15.9383 13.9619ZM17.4985 7.4571L7.46458 13.9642L3.78822 8.29535L5.00855 7.50395L6.39017 9.63438L7.20373 9.10678L5.82211 6.97634L7.72042 5.74526L8.62087 7.13373L9.43443 6.60613L8.53398 5.21765L9.88991 4.33831L12.3943 8.20001L13.2078 7.6724L10.7035 3.81071L11.7882 3.10724L13.4906 5.73232L14.3042 5.20471L12.6018 2.57963L13.8221 1.78822L17.4985 7.4571ZM8.59458 14.7724L10.315 15.7369L17.9544 10.7827L17.7754 8.81846L8.59458 14.7724Z",
  fill: "white"
});

function SvgFooterDetailingPaintCorrection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterDetailingPaintCorrection);
export default __webpack_public_path__ + "static/media/footer-detailing-paint-correction.049520fe.svg";
export { ForwardRef as ReactComponent };